import * as M from "materialize-css";
import { DOM } from "../../../../../../public/js/utils/DOM";
import {FormValidator} from "../../../../../../public/js/utils/Validator/FormValidator";
import { ControlsForm } from "../../../../Form/Form";
import { Networking } from "../../../../../../public/js/utils/Netwtorking";
import {RequestTypes } from "../../../../../../public/js/definitions/utils/networking/RequestTypes";
import {LinkBuilder} from "../../../../../../public/js/utils/LinkBuilder";
import {ControlsWelcomeLoginRecoveryControl} from "../RecoveryControl/RecoveryControl";
import {CodeInput} from "../../../../../../public/js/elements/codeInput";

export namespace ControlsWelcomeLoginLoginControl {

    class Config {
        public static readonly loginFormId = "frm-login-loginForm";
        public static readonly loginFormSubmitId = "buttonLogin";
        public static readonly loginControl = "login";
        public static readonly loginCallBack = "Login";
        public static readonly controlElementId = "LoginControl";
        public static readonly showRecoveryId = "showRecovery";
        public static readonly showRecoveryCallback = "ShowRecoveryView";
        public static readonly verifyCodeBackendCallback = "Verify";
        public static readonly twoFactorTokenInputId = "twoFactorToken";
        public static readonly twoFactorPhoneInputId = "twoFactorPhone";
        public static readonly twoFactorTypeInputId = "twoFactorType";
        public static readonly clientIdInputId = "clientId";
        public static readonly codeInputId = "loginControlCodeInput";
        public static readonly codeInputErrorClassName = "codeInput-error";
    }

    export class Control {

        public static load() : void {

            this.triggerLoginForm();
            this.triggerShowRecovery();
        }

        private static triggerLoginForm() : void {

            const formElement = DOM.Parser.getHtmlElement(Config.loginFormId) as HTMLFormElement;
            const loginButton = DOM.Parser.getHtmlElement(Config.loginFormSubmitId) as HTMLInputElement;
            FormValidator.validateForm({form: formElement, forceSubmitButton: loginButton});
            M.updateTextFields();

            loginButton.addEventListener('click', (event: MouseEvent) => {
                void ControlsForm.Controller.sendFormDataRequest(formElement, {
                    forceDisabledButtons: [loginButton],
                    linkParameters: {component: Config.loginControl, method: Config.loginCallBack, parameters: []},
                    formData: ControlsForm.Controller.getFormData(formElement),
                    event: event,
                    snippetCallback: (name: string, element: HTMLElement) => {
                        if (element.querySelector('#' + Config.twoFactorTokenInputId)) {
                            this.triggerEnterCodeForm();
                        }
                        else if (element.querySelector('#' + Config.loginFormId)) {
                            this.triggerLoginForm();
                            this.triggerShowRecovery();
                        }
                    }
                })
            });
        }

        private static triggerEnterCodeForm() : void {

            const controlElement = DOM.Parser.getHtmlElement(Config.controlElementId);
            const codeInputElement = DOM.Parser.getHtmlElement(Config.codeInputId, controlElement);

            CodeInput.init({finishCallback: (code: string) => {
                const twoFactorToken = (DOM.Parser.getHtmlElement(Config.twoFactorTokenInputId) as HTMLInputElement).value;
                const twoFactorPhone = (DOM.Parser.getHtmlElement(Config.twoFactorPhoneInputId) as HTMLInputElement).value;
                const twoFactorType = (DOM.Parser.getHtmlElement(Config.twoFactorTypeInputId) as HTMLInputElement).value;
                    const clientId = (DOM.Parser.getHtmlElement(Config.clientIdInputId) as HTMLInputElement).value;
                    void Networking.NetworkingController.createRequest({
                        type: RequestTypes.POST,
                        data: {
                            twoFactorType : twoFactorType.toString().trim(),
                            twoFactorToken : twoFactorToken.toString().trim(),
                            twoFactorPhone: twoFactorPhone.toString().trim(),
                            code: code,
                            clientId: clientId
                        },
                        url: LinkBuilder.LinkBuilderController.composeLink({

                            component: Config.loginControl,
                            method: Config.verifyCodeBackendCallback,
                            parameters: [],
                        }),
                        // We need to remove error element, because result is not redraw but redirect
                        startCallback: () => {
                            CodeInput.showProgress(codeInputElement);
                            if (document.getElementsByClassName(Config.codeInputErrorClassName).length > 0) {
                                DOM.Parser.getHtmlElementByClass(Config.codeInputErrorClassName, codeInputElement).remove();
                            }
                        },
                        completedCallback: () => {
                            CodeInput.hideProgress(codeInputElement);
                        },
                        successCallback: () => {
                            this.triggerEnterCodeForm();
                        }
                    });
                }});
        }

        private static triggerShowRecovery() : void {

            DOM.Parser.getHtmlElement(Config.showRecoveryId).addEventListener('click', () => {
                void Networking.NetworkingController.createRequest({
                    type: RequestTypes.GET,
                    url: LinkBuilder.LinkBuilderController.composeLink({
                        component: null, method: Config.showRecoveryCallback, parameters: [{name: 'recoveryView', value : 1}],
                    }),
                    successCallback: () => {
                        ControlsWelcomeLoginRecoveryControl.Control.load();
                    }
                });
            });
        }
    }
}